import React, { memo } from 'react';
import PropTypes from 'prop-types';


export const PressureArrowIndicator = memo(({ width=6.7, height=10.62, pressureArrowDirection }) => {

    return (
        pressureArrowDirection >= 0 && <svg viewBox='0 0 7 10' xmlns='http://www.w3.org/2000/svg' width={width} height={height}  transform={`rotate(${pressureArrowDirection})`}>
            <rect x='2.644' y='1.667' width='1.556' height='8.333' rx='1'/>
            <path d='M2.878 1.762A.87.87 0 012.883.59.742.742 0 013.978.584l2.21 2.368c.301.322.301.845-.005 1.173a.742.742 0 01-1.095.005l-2.21-2.368z'/>
            <path d='M2.755.584A.737.737 0 013.85.589a.876.876 0 01.005 1.173L1.645 4.13A.737.737 0 01.55 4.125a.876.876 0 01-.005-1.173L2.755.584z'/>
        </svg>
    );
});


PressureArrowIndicator.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    pressureArrowDirection: PropTypes.number,
};

PressureArrowIndicator.displayName = 'PressureArrowIndicator';
